import {upperFirst, replace} from "lodash/string";

export default {
    props: {
        field: {
            required: true,
            type: String,
        },
        lang: {
            type: String,
            default: null,
        },
        value: {
            required: true,
            validator: value => typeof value === 'string' || value === null || typeof value === "object",
            default: null
        }
    },
    data: function () {
        return {
            currentValue: null,
        }
    },
    methods: {
        handleValue() {
            let value = this.value;

            if (value === 'true' || value === 'false') {
                value = value === 'true';
            } else if (value === null || value === undefined || value === 'null') {
                value = '';
            }

            this.currentValue = value;
        },
        translateLabel() {
            let field = this.$store.state.composer.translations.field[this.field];

            if(field) {
                return this.$store.state.composer.translations.field[this.field].label;
            }

            return this.field + ` (NO TRANSLATION FOUND)`;
        }
    },
    computed: {
        getId() {
            let prefix = 'field-' + this.field;
            if (this.lang) {
                return prefix + '-' + this.lang;
            }
            return this.field
        },
        getLabel() {
            return upperFirst(
                (this.translateLabel() ? this.translateLabel() : replace(this.lang ? this.field + ` (${this.lang})` : this.field, '_', ' '))
            );
        },
    },
    watch: {
        value(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.handleValue();
            }
        },
        currentValue(newValue, oldValue) {
            if (newValue !== oldValue && oldValue !== null) {
                let data = {
                    field: this.field,
                    value: this.currentValue
                };

                if (this.lang !== null) {
                    data['lang'] = this.lang;
                }

                this.$emit('updated', data);
            }
        }
    },
    created() {
        this.handleValue();
    }
};
